import { styled } from '@linaria/react';
import { newCOLORS } from '../../../styles/colors';
import { Checkbox } from '../../../ui-library/checkbox/checkbox';
import { Text } from '../../../ui-library/typography/typography';

type Props = {
  name: string;
  color: string;
  description: string;
  value: number | string;
  isPercentage?: boolean;
  onClick?: () => void;
  isSelected?: boolean;
  showCheckbox?: boolean;
  isChecked?: boolean;
  onCheckboxChange?: (checked: boolean) => void;
};

export const PhaseBox = ({
  name,
  color,
  description,
  value,
  isPercentage,
  onClick,
  isSelected,
  showCheckbox = false,
  isChecked = true,
  onCheckboxChange,
}: Props) => {
  const displayValue = isPercentage ? `${value}%` : value.toString();

  return (
    <PhaseCard $color={color} $clickable={onClick !== undefined} onClick={onClick} $isSelected={isSelected ?? false}>
      {showCheckbox && (
        <TopRow>
          <Checkbox
            checked={isChecked}
            onChange={(e) => {
              e.stopPropagation();
              onCheckboxChange?.(e.currentTarget.checked);
            }}
            onClick={(e) => e.stopPropagation()}
            size="xs"
          />
        </TopRow>
      )}
      <ContentContainer>
        <HeaderSection>
          <TitleContainer>
            <Text size="medium" weight="medium" color={newCOLORS.black}>
              {name}
            </Text>
          </TitleContainer>
          {!showCheckbox && (
            <Text size="small" weight="medium" color="#979c9e" style={{ textAlign: 'center', width: '100%' }}>
              {description}
            </Text>
          )}
        </HeaderSection>
        <ValueSection>
          <ValueContainer>
            <Text size="large" weight="bold" color={newCOLORS.black}>
              {displayValue}
            </Text>
          </ValueContainer>
        </ValueSection>
      </ContentContainer>
    </PhaseCard>
  );
};

const PhaseCard = styled.div<{ $color: string; $clickable: boolean; $isSelected: boolean }>`
  background-color: ${(props) => (props.$isSelected ? `${props.$color}20` : '#fcfcfc')};
  border: ${(props) => (props.$isSelected ? '3px' : '1px')} solid ${(props) => props.$color};
  border-radius: 16px;
  padding: 8px;
  min-height: 90px;
  flex: 0 0 auto;
  width: 120px;
  min-width: 120px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: ${(props) => (props.$clickable ? 'pointer' : 'default')};
  transition: all 0.2s ease-in-out;

  &:hover {
    box-shadow: ${(props) => (props.$clickable ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none')};
    transform: ${(props) => (props.$clickable ? 'translateY(-2px)' : 'none')};
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0px 2px;
  width: 100%;
  margin-bottom: 8px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 100%;
  flex: 1;
`;

const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
`;

const ValueSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;
